import React from 'react'
import type { WidgetOption } from './index'
import { humanize } from '@ztechapps/common.utils'
import { Row } from '@ztechapps/webui.data-tools'
import { CheckboxInput } from '@ztechapps/webui.input'
import { useDashboardContext } from '../Context'

export const ListRow = (props: WidgetOption) => {
  const { saving, widgetLabels } = useDashboardContext()

  return (
    <Row {...props}>
      <td style={{ width: '10px' }}>
        <CheckboxInput checked={props.check} disabled={saving} />
      </td>
      <td>{widgetLabels?.[props?.value] ?? humanize(props?.value)}</td>
    </Row>
  )
}
